import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export interface PageWrapperProps {
  className: string;
  headerText?: string;
  headerVariant?: "h1" | "h2" | "h3";
  headerContent?: ReactNode;
  children?: ReactNode;
  noTopPadding?: boolean;
  noScroll?: boolean;
}

export const PageWrapper = ({
  className,
  headerText,
  headerVariant = "h1",
  children,
  noTopPadding,
  headerContent,
  noScroll
}: PageWrapperProps) => {
  const { t } = useTranslation();
  const paddingAmount = 1;
  return (
    <Box
      sx={{
        flex: 1,
        padding: paddingAmount,
        paddingTop: noTopPadding ? 0 : paddingAmount,
        display: "flex",
        flexDirection: "column",
        minHeight: 0
      }}
      className={`${className} PageWrapper`}
    >
      {headerText && (
        <Typography variant={headerVariant}>{t(headerText)}</Typography>
      )}
      {headerContent}
      <Grid
        xs={12}
        sx={{ minHeight: 0, overflowY: noScroll ? "initial" : "scroll" }}
        spacing={2}
        display="flex"
        flex={1}
        flexDirection="column"
        className="PageContent"
      >
        {children}
      </Grid>
    </Box>
  );
};
